import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import Wrapper from './styled/Wrapper';
import ArrowButton from './styled/ArrowButton';
import Indicator from './styled/Indicator';
import IndicatorLine from './styled/IndicatorLine';
import IndicatorsWrapper from './styled/IndicatorsWrapper';

export default class Paginator extends PureComponent {


  static defaultProps = {
    currentIndex: 0,
    showArrows: false,
    copyPrev: 'previous screen',
    copyNext: 'next screen',
  };

  onPrevClick = () => {
    const { onPageSelect, currentIndex } = this.props;

    onPageSelect(currentIndex - 1);
  };

  onNextClick = () => {
    const { onPageSelect, currentIndex } = this.props;

    onPageSelect(currentIndex + 1);
  };

  render() {
    const {
      className,
      numPages,
      showArrows,
      currentIndex,
      copyPrev,
      copyNext,
      onPageSelect,
    } = this.props;

    return (
      <Wrapper className={className}>
        {showArrows && (
          <ArrowButton
            prev
            label={copyPrev}
            hidden={currentIndex === 0}
            onClick={this.onPrevClick}
          />
        )}
        <IndicatorsWrapper>
          {new Array(numPages).fill().map((_, index) => (
            <Indicator
              key={`indicator-${index}`}
              isActive={currentIndex === index}
              onClick={() => onPageSelect(index)}
            >
              <IndicatorLine isActive={currentIndex === index} />
            </Indicator>
          ))}
        </IndicatorsWrapper>
        {showArrows && (
          <ArrowButton
            next
            label={copyNext}
            hidden={currentIndex === numPages - 1}
            onClick={this.onNextClick}
          />
        )}
      </Wrapper>
    );
  }
}
